<svelte:options accessors/>
<script>
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";

</script>
<section class="max-w-300px">
    <div class="mb-1">
        <NauiSelect label="Tipo de certificado" options="[]" />
    </div>
    <div class="mb-1">
        <NauiSelect label="Año" options="[]" />
    </div>
    <div class="mb-1">
        <NauiSelect label="Dirigido a" options="[]" />
    </div>
    <div class="mb-1">
        <NauiInput label="Nombre" />
    </div>

    <div class="mt-15">
        <NauiButton caption="Descargar" color="accent" mode="solid" className="min-w-300px"/>
    </div>
</section>